/*
 * Sonatype Nexus (TM) Open Source Version
 * Copyright (c) 2008-present Sonatype, Inc.
 * All rights reserved. Includes the third-party code listed at http://links.sonatype.com/products/nexus/oss/attributions.
 *
 * This program and the accompanying materials are made available under the terms of the Eclipse Public License Version 1.0,
 * which accompanies this distribution and is available at http://www.eclipse.org/legal/epl-v10.html.
 *
 * Sonatype Nexus (TM) Professional Version is available from Sonatype, Inc. "Sonatype" and "Sonatype Nexus" are trademarks
 * of Sonatype, Inc. Apache Maven is a trademark of the Apache Software Foundation. M2eclipse is a trademark of the
 * Eclipse Foundation. All other trademarks are the property of their respective owners.
 */

import { useTransitionHook } from '@uirouter/react';
import { useState, useEffect } from 'react';
import { ROUTE_NAMES } from '../routerConfig/routeNames/routeNames';

export default function useSideNavbarCollapsedState(initState) {
  const [isOpen, setIsOpen] = useState(initState);
  const [savedOpenState, setSavedOpenState] = useState(isOpen);

  const onToggleClick = () => {
    setSavedOpenState(!isOpen);
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleGlobalToggle = (e) => {
      const shouldOpen = e.detail?.open;
      if (shouldOpen !== undefined) {
        setIsOpen(shouldOpen);
      } else {
        setIsOpen(prev => !prev);
      }
    };

    window.addEventListener('nx-sidebar-toggle', handleGlobalToggle);
    return () => window.removeEventListener('nx-sidebar-toggle', handleGlobalToggle);
  }, []);

  useTransitionHook('onSuccess', {}, transition => {
    const prevState = transition.from().name;
    const currentState = transition.to().name;
    const isCurrentRouteAdmin = currentState.includes(ROUTE_NAMES.ADMIN.DIRECTORY);
    const isPreviousRouteAdmin = prevState && prevState.includes(ROUTE_NAMES.ADMIN.DIRECTORY);
    const isNavigationInOrOutOfAdmin = isCurrentRouteAdmin !== isPreviousRouteAdmin;
    if (isNavigationInOrOutOfAdmin) {
      if (isCurrentRouteAdmin) {
        setIsOpen(false);
      } else {
        setIsOpen(savedOpenState);
      }
    }
  });

  return [isOpen, onToggleClick];
}
